const DEFAULT_SEARCH_DELAY = 300;

/**
 * Wraps a Compass `useAsyncSearch`-style search function with a leading
 * delay, acting as a debounce: `useAsyncSearch` aborts the previous call's
 * signal on every keystroke, so a superseded call wakes up mid-delay, sees
 * `signal.aborted`, and resolves to `[]` without ever reaching `search`.
 *
 * Callers are expected to skip calling this for an empty query themselves,
 * so clearing the input doesn't wait out the delay.
 */
export const withSearchDelay =
  <Query, Result>(
    search: (query: Query, signal: AbortSignal) => Promise<Result>,
    delay = DEFAULT_SEARCH_DELAY,
  ) =>
  async (query: Query, signal: AbortSignal): Promise<Result | []> => {
    await new Promise(resolve => setTimeout(resolve, delay));
    if (signal.aborted) return [];
    return search(query, signal);
  };
